const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change'
};

renderLikedProducts();

function likeProduct(product, url, metafields, e) {
    let likedProducts = getLikedProducts()
    const productObject = {...product, url, metafields};
    const isDuplicate = likedProducts.some(likedProduct =>
        JSON.stringify(likedProduct) === JSON.stringify(productObject));

    if (!isDuplicate) {
        likedProducts.push(productObject);
        localStorage.setItem('likedProducts', JSON.stringify(likedProducts));
        window.dispatchEvent(new Event("storage"));
    } else {
        localStorage.setItem('likedProducts', JSON.stringify(likedProducts.filter(p => p.id != product.id)));
        window.dispatchEvent(new Event("storage"));
    }
    renderLikedProducts();
}

function getLikedProducts() {
    return JSON.parse(localStorage.getItem('likedProducts')) || [];
}

function getLikedProduct(productId) {
    let likedProducts = getLikedProducts()
    const result = likedProducts.find(product => product.id == productId);
    return result;
}

function isProductLiked(productId) {
    return getLikedProduct(productId) !== undefined;
}

function renderLikedProducts() {
    let likeElements = document.querySelectorAll('[data-product-id]');

    likeElements.forEach(element => {
        let productId = element.dataset.productId;
        if (isProductLiked(productId)) {
            element.classList.add('active');
            element.ariaLabel = 'Entfernen';
        } else {
            element.classList.remove('active');
            element.ariaLabel = 'Produkt merken';
        }
    });
}